// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"878f8981","96":"e0de4b77","165":"feabba8d","435":"c53669dc","471":"3cbcf13f","535":"05d64621","551":"6955e2d7"}[chunkId] + ".chunk.js";
};